import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import { ExerciseLoadType } from "../../../models";
import NotFound from "../../../components/not-found";
import ExerciseLoadTypeService from "../../../services/ExerciseLoadTypeService";
import ExerciseLoadTypeSkeleton from "./skeletons/ExerciseLoadTypeSkeleton";
import ExerciseLoadTypeEditForm from "./ui/ExerciseLoadTypeEditForm";

export default function ExerciseLoadTypeEditPage() {
const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<ExerciseLoadType | null>(null);
  const [loading, setLoading] = useState(true);
  const api = new ExerciseLoadTypeService();

  useEffect(() => {
    if (id) {
      api
        .getExerciseLoadType(parseInt(id))
        .then((data) => {
          setItem(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id]);
 
  if (!loading && !item) return <NotFound message="Load Type not found."></NotFound>;

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Load Types", href: "/admin/app-files" },
          { label: "Edit", href: `/admin/exercise-load-types/edit/${id}`, active: true },
        ]}
      />   
      {loading ? (
        <ExerciseLoadTypeSkeleton />
      ) : null}
      {!loading && item ? (
        <ExerciseLoadTypeEditForm item={item} />
      ):null}
    </main>
  );
}